// extracted by mini-css-extract-plugin
export default {"container":"RnmUzF","padding":"n__mKT","link":"Q57MYT","fullWidth":"tIK1F0"};